import moment from 'moment';
import { Area } from '@antv/g2plot';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { renderTooltip } from '../../../../helpers/Tooltip';

const fill = '#2E90FA';

export default function useProductionDataValue({ container, data = [], getItems }) {
  const [mainGraph, setMainGraph] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    if (container.current) {
      if (mainGraph) {
        mainGraph.update({
          data: data,
          areaStyle: () => {
            return {
              fill,
            };
          },
          tooltip: {
            customContent: (title, data) => {
              if (Array.isArray(data) && data[0]) {
                return renderTooltip({
                  title: t('Production Value'),
                  subTitle: data[0]?.data?.key ? moment(Number(data[0]?.data?.key || 1), 'M').format('MMMM') : title,
                  items: typeof getItems === 'function' ? getItems({ fill, score: data[0]?.data?.Score || 0 }) : [
                    { label: 'Total volume of gold', color: fill, value: `--` },
                    { label: 'Total volume of ore', color: fill, value: `--` },
                    { label: 'Total value', color: fill, value: `$${Number(data[0]?.data?.Score || 0).toLocaleString('en-us')}` },
                  ],
                });
              }

              return '';
            }
          },
          yAxis: {
            tickMethod: () => [1, 2, 3, 4, 5], // TODO: this should be only wehn empty
          },
        });
      } else {
        const area = new Area(container.current, {
          height: 300,
          data: data,
          xField: 'date',
          localRefresh: true,
          animation: false,
          yField: 'Score',
          point: {
            shape: 'round',
            size: 0,
          },
          xAxis: {
            nice: true,
          },
          yAxis: {
            tickMethod: () => [1, 2, 3, 4, 5], // TODO: this should be only wehn empty
          },
          areaStyle: () => {
            return {
              fill,
            };
          },
          color: fill,
          tooltip: {
            customContent: (title, data) => {
              if (Array.isArray(data) && data[0]) {
                return renderTooltip({
                  title: t('Production Value'),
                  subTitle: title,
                  items: typeof getItems === 'function' ? getItems({ fill, score: data[0]?.data?.Score || 0 }) : [
                    { label: 'Total volume of gold', color: fill, value: `--` },
                    { label: 'Total volume of ore', color: fill, value: `--` },
                    { label: 'Total value', color: fill, value: `$${Number(data[0]?.data?.Score || 0).toLocaleString('en-us')}` },
                  ],
                });
              }

              return '';
            },
          }
        });
        area.render();
        setMainGraph(area);
      }
    }
  }, [container, t, data]);
}
